export default __webpack_public_path__ + "static/blob-paint-ba1bb899d1eb81d3efb91a613b1b5ee7.mp4";